<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="green"
          :loading="loading"
        >
          <v-form
            ref="form"
          >
            <v-text-field
              class="purple-input"
              label="Local"
              disabled
              :value="this.equipment ? this.equipment.name: ''"
              @keyup.enter="handleSubmit"
            />
            <v-container class="py-0">
              <data-grid
                :headers="headers"
                :items="access.items"
                :options.sync="options"
                :count-items="access.total"
                :loading="loading"
              >
                <template v-slot:item.timestamp="{ item }">
                  {{formatedTimezone(item.timestamp)}}
                </template>
              </data-grid>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {mapState,} from 'vuex'
    import {toBrowserTimezoneAndFormat} from '../../utils/datetime'

    export default {
        data() {
            return {
                equipment: {},
                access: {},
                options: {
                    page: 1,
                    itemsPerPage: 10,
                    sortBy: ['timestamp'],
                    sortDesc: [false],

                },
                headers: [
                    {text: 'Horário', value: 'timestamp'},
                    {text: 'Pessoa', value: 'person.name', sortable: false},
                    {text: 'Cartão', value: 'person.card_number', sortable: false},
                ],
            }
        },
        computed: {
            ...mapState('person', ['accesslog']),
            ...mapState('account', ['current_unity']),
            ...mapState('app', ['loading']),

        },
        mounted() {
            this.get_access()
            this.get_equipment()
        },
        methods: {
            get_access() {
                this.$store.dispatch('equipment/GET_ACCESS_LOG', {
                    id: this.$route.params.id,
                    options: this.options
                }).then((response) => this.access = response)
            },
            get_equipment() {
                this.$store.dispatch('equipment/GET', {id: this.$route.params.id}).then((response) => {
                    this.equipment = response
                })
            },
            formatedTimezone(timestamp) {
                return toBrowserTimezoneAndFormat(timestamp)
            }
        },
        watch: {
            options: {
                handler() {
                    this.get_access()
                },
                deep: true,
            },
        }
    }
</script>
